interface Props {
  fill: string;
}

const SecretSVG = ({ fill }: Props) => {
  return (
    <svg
      viewBox='0 0 1024 1024'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M454.656 0c90.477714 68.461714 229.156571 112.932571 416.109714 133.485714V560.274286s-30.208 93.184-106.057143 198.217143c-50.980571 69.997714-154.624 146.285714-311.076571 228.937142-152.137143-82.212571-255.561143-160.841143-310.345143-235.666285C61.147429 639.414857 36.571429 559.762286 36.571429 559.762286V133.485714C228.937143 113.371429 368.201143 68.900571 454.656 0zM454.217143 916.48c98.596571-60.635429 195.584-117.906286 250.953143-191.561143 55.369143-73.581714 83.675429-126.464 95.817143-157.769143V193.755429c-28.818286 4.022857-273.92-51.492571-347.282286-113.517715-65.828571 62.610286-319.049143 116.297143-347.867429 112.713143v374.198857c16.822857 34.742857 36.717714 73.069714 93.915429 148.699429 44.032 58.368 147.236571 143.36 254.537143 200.704z m-0.585143-688.274286c87.990857 0 158.793143 70.802286 157.257143 158.208 0 72.557714-47.469714 132.534857-113.371429 152.210286-1.243429 0.365714-4.169143 0.731429-5.412571 1.097143v183.881143c0 19.602286-13.897143 35.693714-33.938286 35.693714-19.602286 0-33.792-15.579429-33.792-35.693714v-181.394286l-5.558857-0.731429a158.573714 158.573714 0 0 1 34.816-313.344zM453.046857 490.788571c56.539429 0 103.277714-46.738286 103.277714-103.277714 0-56.539429-46.811429-103.277714-103.277714-103.277714-56.539429 0-103.350857 46.811429-103.350857 103.277714 0 56.539429 46.811429 103.277714 103.350857 103.277714z'
        fill={fill}
      />
    </svg>
  );
};

export default SecretSVG;
